import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

import {watch} from "vue";
import FOProductDetail from "@/fo-clone/FOProductDetail.vue";
import useGetProductInformations from "@/fo-clone/custom/FOGetProductInformations";
import FOFooter from "@/fo-clone/FOFooter.vue";
import {useI18n} from "vue-i18n";
import ProductPageConfig from "@/components/ProductPageConfig.vue";

// const route = useRoute(); // WARNING: Route not used in BO

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFilePage',
  setup(__props) {

const {t} = useI18n();

// START - Specific to BO to get the product with the good headers
const {product, getProductInfo} = useGetProductInformations();
const {locale} = useI18n();
let timer: ReturnType<typeof setTimeout>;

function watchProductInfo() {
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout( getProductInfo, 100);
}

watch(locale, watchProductInfo, {immediate: true});
// END - Specific to BO to get the product with the good headers

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _mergeProps(_ctx.$attrs, { class: "Product" }), [
    (_unref(product))
      ? (_openBlock(), _createBlock(FOProductDetail, {
          key: 0,
          product: _unref(product)
        }, null, 8, ["product"]))
      : _createCommentVNode("", true),
    _createVNode(FOFooter),
    _createVNode(ProductPageConfig)
  ], 16))
}
}

})